import Vue from 'vue';
import Router from 'vue-router';
import Couriers from '../Couriers';

Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Action,
    //   props: route => ({
    //     merchantHash: route.query.merchant,
    //     restId: route.query.restid,
    //   }),
    // },
    {
      path: '/',
      component: Couriers,
      props: route => ({
        merchantHash: route.query.merchant,
        restId: route.query.restid,
        orderId: null,
      }),
    },
    {
      path: '/act',
      component: Couriers,
      props: route => ({
        merchantHash: route.query.merchant,
        restId: route.query.restid,
        orderId: route.query.order,
      }),
    },
  ],
  mode: 'history',
});



// WEBPACK FOOTER //
// ./src/router/index.js